import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const MessagesLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates,
    myMessages: LazyLoadedStates,
    message: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.messages',
        url: '/messages',
    },
    myMessages: {
        name: 'authenticated.messages.my-messages',
        url: '/my-messages?page&start&end&searchBy',
        params: {
            page: {
                raw: true,
                value: ''
            },
            searchBy: {
                raw: true,
                value: '',
            },
            start: {
                raw: true,
                value: '',
            },
            end: {
                raw: true,
                value: '',
            },
        },
    },
    message: {
        name: 'authenticated.messages.message',
        url: '/:messageRecipientId',
    }
}, 
() => import('src/app/messages/messages.module').then(mod => mod.MessagesModule)
);
